import ResponsiveImage from './ResponsiveImage';
import withMediaQueries from '../../hocs/withMediaQueries';

export default withMediaQueries(ResponsiveImage);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ResponsiveImage/index.js